import { render } from "./wheelDamage.vue?vue&type=template&id=6725b893"
import script from "./wheelDamage.vue?vue&type=script&lang=js"
export * from "./wheelDamage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__